let listeners: Set<() => void> = new Set();

export function onDocumentScroll(f: () => void) {
  listeners.add(f);
  // This function lets you remove the listener...
  return () => {
    listeners.delete(f);
  };
}

function initScrollCheck() {
  let lastCheck = Date.now();
  let timer: NodeJS.Timer;
  window.addEventListener(
    "scroll",
    () => {
      const now = Date.now();
      if (now - lastCheck > 200) {
        listeners.forEach((f) => f());
        lastCheck = now;
      } else {
        clearTimeout(timer);
        timer = setTimeout(() => {
          listeners.forEach((f) => f());
        }, 180);
      }
    },
    {
      passive: true,
    }
  );
}

initScrollCheck();

export function scrollToContactForm() {
  const hash = window.location.hash;
  if (hash === "#contact-form") {
    const contactForm = document.querySelector(
      ".form-component"
    ) as HTMLElement | null;
    if (contactForm) {
      const SCROLL_OFFSET = 100;
      setTimeout(() => {
        window.scrollTo({
          top: contactForm.offsetTop - SCROLL_OFFSET,
          behavior: "smooth",
        });
      }, 100);
    }
  }
}
